// @ts-nocheck
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  makeStyles,
  AppBar as MuiAppBar,
  Icon,
  IconButton,
  Toolbar,
  Typography,
  Box,
  Avatar,
  Badge,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { usePopupState, bindTrigger, bindMenu } from 'material-ui-popup-state/hooks';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../auth';
import { AppThemeContext } from '../../providers/AppThemeProvider';

const useStyles = makeStyles(theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: 'calc(100% - 240px)',
    marginLeft: '240px',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    padding: '0 24px',
  },
  drawerButton: {
    marginLeft: '-8px',
    marginRight: '40px',
  },
  hide: {
    display: 'none',
  },
  title: {
    flexGrow: '1',
    cursor: 'default',
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'default',
  },
  menuButton: {
    padding: '0',
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.main,
  },
  menuSubheader: {
    cursor: 'default',
    outline: '0',
    fontWeight: 'bold',
    padding: theme.spacing(0, 2),
  },
  menuItem: {
    minWidth: '160px',
  },
  badge: {
    top: '12px',
    left: '12px',
    color: theme.palette.primary.main,
  },
  avatar: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    backgroundColor: theme.palette.primary.main,
  },
}));

function AppBar(props) {
  const { theme, setTheme } = useContext(AppThemeContext);
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const currentUser = useSelector(selectCurrentUser);
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'Popover-preferencesMenu',
  });

  const { drawerOpen, onDrawerOpen } = props;

  const handleLanguageChange = lng => {
    i18n.changeLanguage(lng);
    popupState.close();
  };

  const handleThemeChange = name => {
    setTheme(name);
    popupState.close();
  };

  return (
    <MuiAppBar
      id="AppBar"
      position="fixed"
      color="transparent"
      elevation={0}
      className={clsx(classes.appBar, {
        [classes.appBarShift]: drawerOpen,
      })}
    >
      <Toolbar className={classes.toolbar}>
        <IconButton
          id="AppBar-drawerButton"
          onClick={onDrawerOpen}
          className={clsx(classes.drawerButton, {
            [classes.hide]: drawerOpen,
          })}
        >
          <Icon>menu</Icon>
        </IconButton>
        <Typography id="AppBar-title" variant="h6" className={classes.title} noWrap>
          TV 2 Kundecenter
        </Typography>
        {currentUser && (
          <Box className={classes.userInfo}>
            <Typography id="AppBar-username" variant="h6" noWrap>
              {currentUser.name}
            </Typography>
            <IconButton
              id="AppBar-menuButton"
              className={classes.menuButton}
              {...bindTrigger(popupState)}
            >
              <Badge
                classes={{ badge: classes.badge }}
                badgeContent={
                  <Icon>{popupState.isOpen ? 'arrow_drop_up' : 'arrow_drop_down'}</Icon>
                }
              >
                <Avatar id="AppBar-avatar" className={classes.avatar}>
                  <Icon>account_circle</Icon>
                </Avatar>
              </Badge>
            </IconButton>
            <Menu id="AppBar-menu" {...bindMenu(popupState)}>
              <Typography className={classes.menuSubheader} variant="overline">
                {t('preferences.language')}
              </Typography>
              <MenuItem
                className={classes.menuItem}
                selected={i18n.language === 'en'}
                onClick={() => handleLanguageChange('en')}
              >
                {t('preferences.languageEn')}
              </MenuItem>
              <MenuItem
                className={classes.menuItem}
                selected={i18n.language === 'da'}
                onClick={() => handleLanguageChange('da')}
              >
                {t('preferences.languageDa')}
              </MenuItem>
              <Typography className={classes.menuSubheader} variant="overline">
                {t('preferences.theme')}
              </Typography>
              <MenuItem
                className={classes.menuItem}
                selected={theme === 'light'}
                onClick={() => handleThemeChange('light')}
              >
                {t('preferences.themeLight')}
              </MenuItem>
              <MenuItem
                className={classes.menuItem}
                selected={theme === 'dark'}
                onClick={() => handleThemeChange('dark')}
              >
                {t('preferences.themeDark')}
              </MenuItem>
            </Menu>
          </Box>
        )}
      </Toolbar>
    </MuiAppBar>
  );
}

AppBar.propTypes = {
  drawerOpen: PropTypes.bool.isRequired,
  onDrawerOpen: PropTypes.func.isRequired,
};

export default AppBar;
